function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M31.5 21.4c-3.9 1.8-8 6.2-9.9 10.8-1.4 3.3-1.6 12.1-1.6 68 0 60.5.2 64.5 1.9 68.3 2.2 4.7 6.4 8.9 10.4 10.4 3.9 1.5 131.5 1.5 135.4 0 4-1.5 8.2-5.7 10.4-10.4 1.7-3.6 1.9-6.8 1.9-29.8v-25.8l-2.5-2.4c-3.2-3.3-7.8-3.3-11 0l-2.5 2.4v24c0 20.4-.2 24.2-1.6 25.5-1.4 1.4-8.4 1.6-62.4 1.6s-61-.2-62.4-1.6C36.2 161 36 154 36 100s.2-61 1.6-62.4c1.3-1.4 5.1-1.6 25.5-1.6h24l2.4-2.5c3.3-3.2 3.3-7.8 0-11L87.1 20H60.8c-19.7.1-27 .4-29.3 1.4z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M126.5 22.5c-1.6 1.5-2.5 3.6-2.5 5.5s.9 4 2.5 5.5c2.3 2.4 3 2.5 13.7 2.5h11.3l-30.3 30.3C91.6 96 91 96.7 91 100.6c0 5.3 3.1 8.4 8.5 8.4 3.8 0 4.9-.9 34.2-30.2L164 48.5v11.3c0 10.7.1 11.4 2.5 13.7 3.2 3.3 7.8 3.3 11 0l2.5-2.4V24.9l-2.5-2.4-2.4-2.5h-46.2l-2.4 2.5z"
});

function SvgExternalLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266.667,
    height: 266.667,
    viewBox: "0 0 200 200"
  }, props), _ref, _ref2);
}

export default SvgExternalLink;